import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const MaintenanceBreakdown = () => {
  const data = [
    { name: 'Plumbing', value: 35, color: 'var(--color-accent)' },
    { name: 'Electrical', value: 25, color: 'var(--color-warning)' },
    { name: 'General Repairs', value: 20, color: 'var(--color-success)' },
    { name: 'Appliances', value: 12, color: 'var(--color-error)' },
    { name: 'Other', value: 8, color: 'var(--color-muted-foreground)' },
  ];

  return (
    <div className="card">
      <h3 className="text-lg font-semibold text-foreground mb-6 font-heading">Maintenance Cost Breakdown</h3>
      <div className="w-full h-80" aria-label="Maintenance Cost Pie Chart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percent }) => `${name} ${(percent * 100)?.toFixed(0)}%`}
              outerRadius={100}
              fill="#8884d8"
              dataKey="value"
            >
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.color} />
              ))}
            </Pie>
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'var(--color-surface)', 
                border: '1px solid var(--color-border)',
                borderRadius: '10px',
                fontFamily: 'Inter, sans-serif'
              }}
              formatter={(value) => `${value}%`}
            />
            <Legend 
              wrapperStyle={{ 
                fontFamily: 'Inter, sans-serif',
                fontSize: '12px'
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default MaintenanceBreakdown;